import * as editCoordinators from './edit'
import * as loadCoordinators from './load'

export default Object.freeze({
  ...editCoordinators,
  ...loadCoordinators,
})
